import { likeMedia, unlikeMedia, viewMedia } from '@apis/media';
import useMediaDetail from '@hooks/Media/useMediaDetail';
import { useAppSelector } from '@redux/hooks';
import safeExecute from '@utils/safeExecute';
import { useCallback, useMemo } from 'react';

const useMedia = (id: string, interval?: number) => {
  const user = useAppSelector((state) => state.authorization);
  const query = useMemo(() => [id], [id]);
  const { data, loading, error, fetch } = useMediaDetail(query, interval);
  const like = useCallback(async () => {
    if (!user) return;
    await safeExecute(async () => likeMedia(id));
    await fetch();
  }, [fetch, id, user]);

  const unlike = useCallback(async () => {
    if (!user) return;
    await safeExecute(async () => unlikeMedia(id));
    await fetch();
  }, [fetch, id, user]);

  const view = useCallback(async () => {
    if (!user) return;
    await safeExecute(async () => viewMedia(id));
    await fetch();
  }, [fetch, id, user]);

  return {
    data,
    loading,
    error,
    like,
    unlike,
    view,
    fetch,
  };
};

export default useMedia;
